/**
 * @file
 * Toggle header on mobiles.
 *
 */

(($, Drupal) => {
  let once = false;

  Drupal.behaviors.hamburger_icon = {
    attach: (/* context, settings */) => {
      /* Hamburger menu animation  */
      const $hamburgerMenu = $(".ham-menu");

      // insert dots.
      if ($hamburgerMenu.length && !once) {
        $hamburgerMenu.html(
          '<div class="ham-menu__dot"></div><div class="ham-menu__dot"></div><div class="ham-menu__dot"></div>'
        );
        once = true;

        $hamburgerMenu.mouseenter(() => {
          $hamburgerMenu.addClass("is-finished");
        });

        // Init animation
        $hamburgerMenu.addClass("run-animation");
        const interval = setInterval(() => {
          if (!$hamburgerMenu.hasClass("is-finished")) {
            $hamburgerMenu.removeClass("run-animation");
            setTimeout(() => {
              $hamburgerMenu.addClass("run-animation");
            }, 500);
          } else {
            $hamburgerMenu.removeClass("run-animation");
            clearInterval(interval);
            //
          }
        }, 30000);
      }

      /* /Hamburger menu animation  */
    },
  };
})(jQuery, Drupal);
